import React, { useRef, useState, useEffect, useMemo } from "react";
import { getOrderDetailsRashan } from "../../Request/OrderRequests";
import { useSelector } from "react-redux";
import cookie from "react-cookies";
import { mintuesPassed } from "./OrdersStatus";
import { useNavigate } from "react-router";
const HomePageOrderTracking = () => {
  const navigate = useNavigate();
  const user = useSelector((s) => s.user.info);
  const [order, setOrder] = useState(null);

  //getting only the lastest order
  useEffect(() => {
    if (user?.userHash) {
      getOrderDetailsRashan(cookie.load("uid"))
        .then((res) => setOrder(res?.reverse()[0]))
        .catch((err) => console.log(err));
    }
  }, [user]);

  // console.log(order);

  //MAIN JSX RETURN
  return order?.order_id ? (
    <>
      {order?.status === "Pending" || order?.status === "Accepted" ? (
        <>
          {90 - mintuesPassed(order?.orderplaced) > 0 ? (
            <div className="track-order-bar">
              <h4>
                {90 - mintuesPassed(order?.orderplaced)}
                <br />
                mins
              </h4>
              <div>
                <h5>Order #RP{order?.order_id}</h5>

                <p>{`${
                  mintuesPassed(order?.orderplaced) < 27
                    ? "Scanning the order..."
                    : mintuesPassed(order?.orderplaced) > 27 &&
                      mintuesPassed(order?.orderplaced) < 54
                    ? "Packing the order..."
                    : "Out for Delivery..."
                }`}</p>
              </div>
              <button
                type="button"
                onClick={() => navigate(`/orderstatus/${order?.order_id}`)}
              >
                Track Order
              </button>
            </div>
          ) : null}
        </>
      ) : null}
    </>
  ) : null;
};

export default HomePageOrderTracking;
